export default __webpack_public_path__ + "static/media/anon2.6b5d5ff8.png";